/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */


import React from "react";
import { StyledStatisticLoader } from "./styles";

export const StatisticSkeletalLoader = ( { dataTestId } ) => {
  return (
    <StyledStatisticLoader 
      variant="text" 
      animation="wave"
      data-testid={dataTestId}
    />
  )
}
